import React, { CSSProperties, useCallback } from 'react';
import {
  Button,
  Image,
  Input,
  Select,
  InputNumber,
  Form,
  Space,
  Checkbox,
  Tabs,
  Spin,
  Row,
  Col,
  Typography,
  Divider,
} from 'antd';
import { LockFilled, UnlockFilled, LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import {
  fetchWarehouseList,
  fetchWarehouseLocationList,
} from 'services/warehouse';
import { DEFAULT_PRINT_MODE } from 'constants/config';
import { fetchPoNumbers, receive } from 'services/purchaseOrder';
import {
  fetchPrinterList,
  fetchPrintTemplates,
  postPrintReceives,
  // printTask,
} from 'services/print';
import { useDispatch } from 'react-redux';
import { printReceive } from 'actions/printActions';
import { HeaderTitle } from 'components/common';
import { ClearOutlined } from '@ant-design/icons';
import {
  Content,
  FormView,
  ProductInfo,
  ProductInfoText,
  LocationInfo,
  InfoBox,
  LocationInfoBox,
} from './style';
import {
  fetchInventory,
  // inventoryReceive,
  queryProductByKeyword,
} from 'services/product';
// import { fetchInventoryLogs } from "services/inventory";
import { message } from 'components/common';
import dayjs from 'dayjs';
import { FormLabel } from 'components/common';
import { userProfiles } from 'utils/auth';
import { getProfileSettingValue, formatPrinterToTree, getWarehouseIdFromCache } from 'utils';
import moment from 'moment';
import SelectLotUomDialog from '../Add/SelectLotUom'
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

const { TabPane } = Tabs;
const { Link, Text } = Typography;
const { Option } = Select;

/**
 * The type definition for warehouse select option.
 */
type WarehouseOption = {
  id: number;
  label: string;
  value: string;
  name: string;
  warehouseType: number;
  warehouseId: string;
};

type Location = {
  code: string;
  quantity: number;
};

type InventoryLog = {
  po: string;
  sku: string;
  quantity: number;
  location: string;
  lotNumber?: string;
  uom?:string;
  uomRate?: number;
  date: string;
};
const iconStyle: CSSProperties = {
  fontSize: 24,
  marginLeft: 10,
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  bottom: -2,
  height: 32,
};

export default function SearchList() {
  const defaultWarehouseNum = Number(
    localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)
  );
  const [warehouseOptions, setWarehouseOptions] = React.useState<
    WarehouseOption[]
  >([]);
  const [productInfo, setProductInfo] = React.useState<ProductRow>();
  const [selectdWarehouseNum, setSelectedWarehouseNum] =
    React.useState<number>(defaultWarehouseNum ? defaultWarehouseNum : -1);
  const [selectdWarehouseId, setSelectedWarehouseId] =
    React.useState<string>( defaultWarehouseNum ? getWarehouseIdFromCache(defaultWarehouseNum) : '');
  const [po, setPo] = React.useState('');
  const [identifier, setIdentifier] = React.useState('');
  const [locationList, setLocationList] = React.useState<Location[]>([]);
  const [selectedLocation, setSelectedLocation] = React.useState<Location>();
  const [quantity, setQuantity] = React.useState<number>(1);
  const [inventoryLogList, setInventoryLogList] = React.useState<
    InventoryLog[]
  >([]);
  const [PONumberList, setPONumberList] = React.useState<PoNumberRow[]>([]);
  const [printerList, setPrinterList] = React.useState<Printer[]>([]);
  const [printerTree, setPrinterTree] = React.useState<any[]>([]);
  const [printTemplateList, setPrintTemplateList] = React.useState<
    PrintTemplate[]
  >([]);
  const [poLock, setPoLock] = React.useState(true);
  const [identifierLock, setIdentifierLock] = React.useState(false);
  const [locationLock, setLocationLock] = React.useState(false);
  const [quantityLock, setQuantityLock] = React.useState(false);
  const [warehouseLock, setWarehouseLock] = React.useState(false);

  const [needPrint, setNeedPrint] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  //const poInputRef = React.useRef<HTMLInputElement | null>(null);
  const poInputRef = React.useRef<any>(null);
  const identifierInputRef = React.useRef<any | null>(null);
  const quantityInputRef = React.useRef<HTMLInputElement | null>(null);
  const locationInputRef = React.useRef<any | null>(null);
  const firstUpdate = React.useRef(true);
  const [uomEnable, setUomEnable] = React.useState(false);
  const [lotEnable, setLotEnable] = React.useState(false);
  const [timeZone, setTimeZone] = React.useState<string>('');
  const [lotUomInfo, setLotUomInfo] = React.useState<{uom: string, uomRate: number, lotNumber:string}>();
  const [selectLotUomDialogVisible, setSelectLotUomDialogVisible] = React.useState(false);
  const [refreshPrinter, setRefeshPrinter] = React.useState(true);
  const [refreshTemplate, setRefeshTemplate] = React.useState(true);

  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const reSet = () => {
    if(!warehouseLock){
      setSelectedWarehouseNum(defaultWarehouseNum ? defaultWarehouseNum : -1);
      setSelectedWarehouseId(defaultWarehouseNum ? getWarehouseIdFromCache(defaultWarehouseNum) : '')
      form.setFieldsValue({
        Warehouse: defaultWarehouseNum ? `${defaultWarehouseNum},${getWarehouseIdFromCache(defaultWarehouseNum)}` : undefined,
      });
    }

    if (!poLock) {
      form.setFieldsValue({
        po: '',
      });
    }
    if (!identifierLock) {
      setIdentifier('');
      setProductInfo(undefined);
      setLotUomInfo(undefined);
      form.setFieldsValue({
        Identifier: '',
      });
    }
    if (!locationLock) {
      setSelectedLocation(undefined);
      setLocationList([]);
      form.setFieldsValue({
        Location: '',
      });
    }
    if (!quantityLock) {
      setQuantity(1);
      form.setFieldsValue({
        Quantity: 1,
      });
    }
  };

  const getWarehouseList = React.useCallback(async () => {
    try {
      const list = await fetchWarehouseList();
      if (list && Array.isArray(list)) {
        let rawWarehouseList = list.map((e) => {
          return {
            id: e.warehouseNum,
            label: e.warehouseCode,
            name: e.warehouseName,
            value: e.warehouseNum,
            warehouseType: e.warehouseType,
            warehouseId: e.warehouseId,
          };
        });

        setWarehouseOptions(rawWarehouseList);
        firstUpdate.current = false;
      }
    } catch (e) {
      console.log('err', e);
    }
  }, []);

  const getPONumbers = React.useCallback(async () => {
    try {
      setLoading(true);
      const numbers = await fetchPoNumbers();
      setLoading(false);
      setPONumberList(numbers);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, []);

  const getPrinterList = React.useCallback(async () => {
    try {
      const data = await fetchPrinterList();
      setRefeshPrinter(false)
      if (data.isSuccess) {
        setPrinterList(data.data);
        setPrinterTree(formatPrinterToTree(data.data))
      } else {
        message.error({
          content: data.message,
        });
      }
    } catch (err) {
      console.log(err);
      setRefeshPrinter(false)
    }
  }, []);

  const getPrinterTemplateList = React.useCallback(async () => {
    try {
      const profile = userProfiles.profile;
      const data = await fetchPrintTemplates({
        TemplateType: 1,
        MasterAccountNum: profile.masterAccountNum,
        ProfileNum: profile.profileNum,
      });
      setRefeshTemplate(false)
      if (data.isSuccess) {
        setPrintTemplateList(data.data);
      } else {
        message.error({
          content: data.message,
        });
      }
    } catch (err) {
      console.log(err);
      setRefeshTemplate(false)
    }
  }, []);

  const getInventory = useCallback(async()=>{
    try {
      let filter = `sku eq '${productInfo?.sku}'`;
      if(lotUomInfo&&lotUomInfo.lotNumber) filter =`${filter} and lotNumber eq '${lotUomInfo.lotNumber}'`;
      if(lotUomInfo&&lotUomInfo.uom) filter =`${filter} and uom eq '${lotUomInfo.uom}'`
      const list = await fetchInventory(
        {
          id: selectdWarehouseNum,
          warehouseId: selectdWarehouseId,
        },
        {
          $filter: filter,
          virtual: false,
        }
      );
      if (list.data.length > 0) {
        setLocationList(
          list.data.map((item: any) => {
            return {
              code: item.locationCode,
              quantity: item.quantity,
            };
          })
        );
      } else {
        setLocationList([])
      }
    } catch (error) {
      
    }

  },[lotUomInfo, selectdWarehouseNum, selectdWarehouseId, productInfo])

  const getProduct = React.useCallback(async () => {
    try {
      if(identifier && identifier.trim()){
        const products = await queryProductByKeyword(identifier);
        if (products.length > 0) {
          setProductInfo(products[0]);
        } else {
          message.info({ content: 'no matched product' });
          // form.setFieldsValue({Identifier: undefined})
          // identifierInputRef.current.focus()
          identifierInputRef.current.select()
        }
      } else {
        form.setFieldsValue({Identifier: undefined})
      }
    } catch (err) {
      message.error({ content: 'server error' });
    }
  }, [identifier, form]);

  const saveReceive = async () => {
    const reSet = () => {
      if(!warehouseLock){
        setSelectedWarehouseNum(defaultWarehouseNum ? defaultWarehouseNum : -1);
        setSelectedWarehouseId(defaultWarehouseNum ? getWarehouseIdFromCache(defaultWarehouseNum) : '')
        form.setFieldsValue({
          Warehouse: defaultWarehouseNum ? `${defaultWarehouseNum},${getWarehouseIdFromCache(defaultWarehouseNum)}` : undefined,
        });
      }
      if (!poLock) {
        form.setFieldsValue({
          po: '',
        });
      }
      if (!identifierLock) {
        setIdentifier('');
        setProductInfo(undefined);
        setLotUomInfo(undefined);
        form.setFieldsValue({
          Identifier: '',
        });
      }
      if (!locationLock) {
        setSelectedLocation(undefined);
        setLocationList([]);
        form.setFieldsValue({
          Location: '',
        });
      }
      if (!quantityLock) {
        setQuantity(1);
        form.setFieldsValue({
          Quantity: 1,
        });
      }
    };
    if (selectdWarehouseNum < 0) {
      message.error({ content: 'warehouse is not found' });
      return;
    }
    if (!productInfo || !productInfo.sku) {
      message.error({ content: 'Sku is not found' });
      return;
    }
    if (!form.getFieldValue('Location')) {
      console.log('location', form.getFieldValue('Location'));
      message.error({ content: 'location is not found' });
      return;
    }
    // if (!selectedLocation || !selectedLocation.code) {
    //   message.error({ content: "location is not found11" });
    //   return;
    // }

    const locationTemp = await fetchWarehouseLocationList(
      selectdWarehouseId,
      false,
      form.getFieldValue('Location') || selectedLocation?.code
    );
    if (locationTemp.length < 1) {
      message.error({ content: 'location is not found' });
      return;
    }

    const warehouseTemp = warehouseOptions.filter(
      (item) => item.id === selectdWarehouseNum
    )[0];

    const poTemp = PONumberList.filter((item) => item.name === po)[0];

    try {
      setLoading(true);
      // const result = await inventoryReceive(
      //   selectdWarehouseNum,
      //   locationTemp[0].locationNum,
      //   locationTemp[0].locationCode,
      //   productInfo.productId,
      //   productInfo.sku,
      //   quantity,
      //   po,
      //   warehouseTemp?.label,
      //   warehouseTemp?.name
      // );
      const result = await receive(poTemp.fulfillmentPoId, {
        WarehouseNum: warehouseTemp.id,
        Items: [
          {
            FulfillmentPoLineNum: undefined,
            SKU: productInfo.sku,
            ReceiveQty: quantity,
            LocationNum: locationTemp[0].locationNum,
            // LocationCode: locationTemp[0].locationCode,
            // WarehouseCode: warehouseTemp.label,
            ReceiptDate: moment(),
            LotNumber: lotUomInfo?.lotNumber,
            Uom: lotUomInfo?.uom,
            UomRate: lotUomInfo?.uomRate
            // PoPrice: 0,
          },
        ],
      });

      if (result) {
        const profile = userProfiles.profile;
        message.success({ content: 'Received Successfully' });
        // print
        if (needPrint) {
          const printerNum = form.getFieldValue('printer');
          const printTemplateNum = form.getFieldValue('template');
          const selectedPrinter = printerList.filter(
            (item) => item.printerNum === printerNum
          )[0];
          const selectedTemplate = printTemplateList.filter(
            (item) => item.printTemplateNum === printTemplateNum
          )[0];
          const params = {
            SKU: productInfo.sku,
            LotNumber: lotUomInfo?.lotNumber,
            Uom: lotUomInfo?.uom,
            UomRate: lotUomInfo?.uomRate,
            WarehouseCode: warehouseTemp?.label,
            LocationCode: locationTemp[0].locationCode,
            PONumber: po,
            User: profile.email, // TODO no user information
            Quantity: quantity,
            PrinterNum: selectedPrinter.printerNum,
            PrinterAccountNum: selectedPrinter.printerAccountNum,
            PrintTemplateNum: selectedTemplate.printTemplateNum,
            // MasterAccountNum: selectedTemplate.masterAccountNum,
            // ProfileNum: selectedTemplate.profileNum,
            MasterAccountNum: profile.masterAccountNum,
            ProfileNum: profile.profileNum,
            TemplateType: selectedTemplate.templateType,
            Qty: 1,
          };
          const printMode = await getProfileSettingValue(
            'PrintStationMode',
            DEFAULT_PRINT_MODE
          );
          if (printMode === DEFAULT_PRINT_MODE) {
            dispatch(printReceive(params)); //test signalR print
          } else {
            const res1 = await postPrintReceives(params);
            if (res1.isSuccess) {
              message.success({ content: 'Add printTask success' });
            } else {
              message.info({ content: res1.message });
            }
          }

          // const printResult = await printTask(params);
          // console.log(printResult);
          // if (printResult.isSuccess) {
          //   message.success({ content: "Add printer task success!" });
          // } else {
          //   message.error({ content: printResult.message });
          // }
        }
        setLoading(false);
        // add item to history
        setInventoryLogList((prev) => {
          return [
            {
              po: po,
              sku: productInfo.sku || '',
              lotNumber: lotUomInfo?.lotNumber,
              uom: lotUomInfo?.uom,
              uomRate: lotUomInfo?.uomRate,
              quantity: quantity,
              location: locationTemp[0].locationCode || '',
              date: dayjs().format('YYYY-MM-DD hh:mm:ss') || '',
            },
            ...prev,
          ];
        });
        reSet();
      } else {
        message.warning({ content: 'Received failed!' });
      }
    } catch (err: any) {
      setLoading(false);
      // message.error({ content: err.response.data.error });
      console.log(err);
    }
  };

  const warehouseCodeSelectOptions = () => {
    return warehouseOptions
      .filter((w) => (w.warehouseType === 1 || w.warehouseType === 5))
      .map((e) => (
        <Select.Option
          key={e.id}
          label={e.label}
          value={`${e.id},${e.warehouseId}`}
        >
          {e.label}
        </Select.Option>
      ));
  };

  const handlePoPressEnter = () => {
    getProduct();
  };

  const handleWarehouseCodeChange = (value: string) => {
    setSelectedWarehouseNum(Number(value.split(',')[0]));
    setSelectedWarehouseId(value.split(',')[1]);
  };

  const handleSubmit = () => {
    // e.preventDefault();
    form
      .validateFields()
      .then((values) => {
        saveReceive();
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  React.useEffect(() => {
    getWarehouseList();
    getPONumbers();
    getPrinterList();
    getPrinterTemplateList();
  }, [getPONumbers, getPrinterList, getPrinterTemplateList, getWarehouseList]);

  React.useEffect(() => {
    if (!locationLock && !firstUpdate.current) {
      locationInputRef.current?.focus();
      locationInputRef.current?.setSelectionRange(0, -1);
    }
  }, [locationLock]);
  React.useEffect(() => {
    if (!identifierLock && !firstUpdate.current) {
      identifierInputRef.current?.focus();
      identifierInputRef.current?.setSelectionRange(0, -1);
    }
  }, [identifierLock]);
  React.useEffect(() => {
    if (!quantityLock && !firstUpdate.current) {
      quantityInputRef.current?.focus();
      quantityInputRef.current?.setSelectionRange(0, -1);
    }
  }, [quantityLock]);
  React.useEffect(() => {
    if (!poLock && !firstUpdate.current) {
      poInputRef.current?.focus();
    }
  }, [poLock]);

  const getSetting = React.useCallback(async () => {
    const res1 = await getProfileSettingValue('EnableLOT', '0');
    const res2 = await getProfileSettingValue('EnableUOM', '0');
    const res3 = await getProfileSettingValue('TimeZone');
    setLotEnable(res1 === '1');
    setUomEnable(res2 === '1');
    setTimeZone(res3);
  }, []);

  React.useEffect(() => {
    getSetting();
  }, [getSetting]);

  React.useEffect(()=>{
    if(productInfo && productInfo.sku){
      if(uomEnable || lotEnable){
        setSelectLotUomDialogVisible(true)
      }
    }
  },[productInfo, uomEnable, lotEnable])

  /* eslint-disable */
  React.useEffect(() => {
    if (selectdWarehouseId && selectdWarehouseNum) {
      if(!uomEnable&&!lotEnable){
        if (productInfo) {
          getInventory()
        }
      } else {
        if(productInfo && lotUomInfo){
          getInventory()
        }
      }
    }
  }, [selectdWarehouseId, selectdWarehouseNum, lotUomInfo, productInfo ]);
  /* eslint-enable */

  React.useEffect(() => {
    if (refreshTemplate) {
      getPrinterTemplateList();
    }
  }, [getPrinterTemplateList, refreshTemplate]);

  React.useEffect(() => {
    if (refreshPrinter) {
      getPrinterList();
    }
  }, [getPrinterList, refreshPrinter]);

  return (
    <>
      <HeaderTitle breadcrumb={['Inventory', 'Receive']}></HeaderTitle>
      <Content>
        <FormView>
          <Spin
            spinning={loading}
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          >
            <Form
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 12 }}
              form={form}
              onFinish={handleSubmit}
              layout="horizontal"
              size="middle"
            >
              <Form.Item required label={<FormLabel>Warehouse</FormLabel>}>
              <Form.Item
                noStyle
                name="Warehouse"
                initialValue={defaultWarehouseNum ? `${defaultWarehouseNum},${getWarehouseIdFromCache(defaultWarehouseNum)}` : undefined}
              >
                <Select
                  style={{ width: '80%' }}
                  showSearch
                  optionFilterProp="label"
                  onChange={handleWarehouseCodeChange}
                >
                  {warehouseCodeSelectOptions()}
                </Select>
              </Form.Item>
              {warehouseLock ? (
                  <LockFilled
                    onClick={() => setWarehouseLock(false)}
                    style={{ ...iconStyle, color: 'red' }}
                  />
                ) : (
                  <UnlockFilled
                    onClick={() => setWarehouseLock(true)}
                    style={iconStyle}
                  />
                )}
              </Form.Item>
              <Form.Item required label={<FormLabel>PO #</FormLabel>}>
                <Form.Item
                  rules={[{ required: true }]}
                  name="po"
                  label="inputPo"
                  noStyle
                >
                  {/* <Input
                    style={{ width: "80%" }}
                    disabled={poLock}
                    ref={poInputRef}
                    onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                      setPo(evt.target.value)
                    }
                  /> */}
                  <Select
                    showSearch
                    showAction={['focus']}
                    style={{ width: '80%' }}
                    ref={poInputRef}
                    // disabled={poLock}
                    placeholder="select a purchase order number"
                    onChange={(value) => setPo(value as string)}
                    filterOption={(input, option) => {
                      if (option) {
                        const { children } = option;

                        if (typeof children === 'string') {
                          return (
                            (children as string)
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          );
                        }
                      }

                      return false;
                    }}
                  >
                    {PONumberList.map((item, index) => (
                      <Option key={index} value={item.name}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                {poLock ? (
                  <LockFilled
                    onClick={() => setPoLock(false)}
                    style={{ ...iconStyle, color: 'red' }}
                  />
                ) : (
                  <UnlockFilled
                    onClick={() => setPoLock(true)}
                    style={iconStyle}
                  />
                )}
              </Form.Item>
              <Form.Item required label={<FormLabel>Identifier</FormLabel>}>
                <Form.Item
                  rules={[{ required: true }]}
                  label="inputIndentifier"
                  name="Identifier"
                  noStyle
                >
                  <Input
                    style={{ width: '80%' }}
                    ref={identifierInputRef}
                    placeholder="enter sku then press enter to find"
                    // disabled={identifierLock}
                    onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                      setIdentifier(evt.target.value);
                      productInfo && setProductInfo(undefined);
                      locationList.length !== 0 && setLocationList([]);
                    }}
                    onBlur={handlePoPressEnter}
                    // onKeyDown={(e) => e.keyCode === 9 && handlePoPressEnter()}
                    onPressEnter={handlePoPressEnter}
                  />
                </Form.Item>
                {identifierLock ? (
                  <LockFilled
                    onClick={() => setIdentifierLock(false)}
                    style={{ ...iconStyle, color: 'red' }}
                  />
                ) : (
                  <UnlockFilled
                    onClick={() => setIdentifierLock(true)}
                    style={iconStyle}
                  />
                )}
              </Form.Item>
              {lotUomInfo && <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                <Space size="large">
                  {lotEnable&&<Text><Text strong>LOT#: </Text><Text>{lotUomInfo?.lotNumber}</Text></Text>}
                  {uomEnable&&<Text><Text strong>UOM: </Text><Text>{lotUomInfo?.uom}</Text></Text>}
                  {uomEnable&&<Text><Text strong>Rate: </Text><Text>{lotUomInfo?.uomRate}</Text></Text>}
                </Space>
              </Form.Item>}
              <Form.Item required label={<FormLabel>Location</FormLabel>}>
                <Form.Item
                  rules={[{ required: true }]}
                  label="inputLocation"
                  name="Location"
                  noStyle
                >
                  <Input
                    style={{ width: '80%' }}
                    // disabled={locationLock}
                    ref={locationInputRef}
                  />
                </Form.Item>
                {locationLock ? (
                  <LockFilled
                    onClick={() => setLocationLock(false)}
                    style={{ ...iconStyle, color: 'red' }}
                  />
                ) : (
                  <UnlockFilled
                    onClick={() => setLocationLock(true)}
                    style={iconStyle}
                  />
                )}
              </Form.Item>
              <Form.Item required label={<FormLabel>Quantity</FormLabel>}>
                <Form.Item
                  rules={[{ required: true }]}
                  label="inputNumber"
                  name="Quantity"
                  noStyle
                >
                  <InputNumber
                    min={1}
                    max={999999}
                    ref={quantityInputRef}
                    // disabled={quantityLock}
                    keyboard={true}
                    onChange={(evt: number) => setQuantity(evt)}
                    // defaultValue={1}
                  />
                </Form.Item>
                {quantityLock ? (
                  <LockFilled
                    onClick={() => setQuantityLock(false)}
                    style={{ ...iconStyle, color: 'red' }}
                  />
                ) : (
                  <UnlockFilled
                    onClick={() => setQuantityLock(true)}
                    style={iconStyle}
                  />
                )}
                {uomEnable && <Text>{`Base Qty: ${(lotUomInfo?.uomRate || 1) * Number(quantity || 1)}`}</Text>}
              </Form.Item>
              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" onClick={handleSubmit}>
                  Receive
                </Button>
                <Button style={{ margin: '0 8px' }} onClick={reSet}>
                  <ClearOutlined />
                  Reset
                </Button>
              </Form.Item>
              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Space>
                  <Checkbox
                    checked={needPrint}
                    onChange={() => {
                      setNeedPrint((prev) => !prev);
                    }}
                  />
                  <Text strong>Print labels on receive</Text>
                </Space>
              </Form.Item>
              <Form.Item label={<FormLabel>Printer</FormLabel>}>
              <Form.Item
                name="printer"
                rules={[
                  needPrint
                    ? { type: 'number', required: true }
                    : { type: 'number' },
                ]}
                label={<Button
                  id="refresh_printer_button"
                  icon={
                    <ReloadOutlined
                      spin={refreshPrinter}
                      style={{ fontSize: 12, color: 'green' }}
                    />
                  }
                  onClick={() => setRefeshPrinter(true)}
                />}
              >
                {/* <Select style={{ width: '80%' }}>
                  {printerList.map((item, index) => (
                    <Select.Option key={index} value={item.printerNum}>
                      {item.printerName}
                    </Select.Option>
                  ))}
                </Select> */}
                <Select
                  style={{ width: '80%' }}
                  optionLabelProp="label"
                >
                  {printerTree?.map((item: any) => {
                        return (
                          <Select.OptGroup
                            key={item.label}
                            label={item.label}
                          >
                            {item.options.map((citem: any) => {
                                return (
                                  <Select.Option
                                    key={citem.value}
                                    value={citem.value}
                                    label={`${item.label} - ${citem.label}`}
                                  >
                                    {citem.label}
                                  </Select.Option>
                                );
                              })
                              }
                          </Select.OptGroup>
                        );
                      })}
                </Select>
              </Form.Item>
              </Form.Item>
              <Form.Item label={<FormLabel>Template</FormLabel>}>
              <Form.Item
                name="template"
                rules={[
                  needPrint
                    ? { type: 'number', required: true }
                    : { type: 'number' },
                ]}
                label={
                  <Button
                  id="refresh_print_template_button"
                  icon={
                    <ReloadOutlined
                      spin={refreshTemplate}
                      style={{ fontSize: 12, color: 'green' }}
                    />
                  }
                  onClick={() => setRefeshTemplate(true)}
                />
                }
              >
                <Select style={{ width: '80%' }}>
                  {printTemplateList.map((item, index) => (
                    <Select.Option key={index} value={item.printTemplateNum}>
                      {item.templateName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              </Form.Item>
            </Form>
          </Spin>
        </FormView>
        <InfoBox>
          <LocationInfo>
            <Tabs defaultActiveKey="1" type="card" size="large">
              <TabPane tab="Locations" key="1">
                {productInfo && (
                  <ProductInfo>
                    <ProductInfoText>
                      <Space align="start" direction="vertical">
                        <span>
                          <FormLabel>SKU</FormLabel>
                          {productInfo.sku}
                        </span>
                        <span>
                          <FormLabel>Product Name </FormLabel>
                          {productInfo.productTitle}
                        </span>
                        <span>
                          <FormLabel>UPC </FormLabel>
                          {productInfo.upc}
                        </span>
                        { lotEnable &&
                            <span>
                            <FormLabel>LOT# </FormLabel>
                            {lotUomInfo?.lotNumber}
                          </span>
                        }
                        { uomEnable &&
                          <span>
                          <FormLabel>UOM </FormLabel>
                          {lotUomInfo?.uom}
                        </span>
                        }
                        { uomEnable &&
                          <span>
                          <FormLabel>Rate </FormLabel>
                          {lotUomInfo?.uomRate}
                        </span>
                        }

                      </Space>
                    </ProductInfoText>
                    <Image
                      width={150}
                      height={150}
                      src={
                        productInfo.pictureUrl
                          ? productInfo.pictureUrl
                          : 'error'
                      }
                      fallback="data:image/png;base64,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"
                    />
                    <div />
                  </ProductInfo>
                )}
                <LocationInfoBox>
                  {locationList.length === 0 && (
                    <Text type="secondary" strong>
                      No location found
                    </Text>
                  )}
                  {locationList.length > 0 && (
                    <Row>
                      <Col span={8}>
                        <Text strong>Location</Text>
                      </Col>
                      <Col span={8}>
                        <Text strong>Quantity</Text>
                      </Col>
                      <Col span={8}></Col>
                    </Row>
                  )}
                  {locationList.map((item, index) => (
                    <div key={index}>
                      <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                      <Row>
                        <Col span={8}>
                          <Link
                            onClick={() => {
                              setSelectedLocation(item);
                              form.setFieldsValue({
                                Location: item.code,
                              });
                            }}
                            strong
                          >
                            {item.code}
                          </Link>
                        </Col>
                        <Col span={8}>
                          <Text>{item.quantity}</Text>
                        </Col>
                        <Col span={8}></Col>
                      </Row>
                    </div>
                  ))}
                </LocationInfoBox>
              </TabPane>
              <TabPane tab="History" key="2">
                <LocationInfoBox>
                  <Text type="secondary">
                    {inventoryLogList.length === 0
                      ? `No transaction found`
                      : `All history will be Cleared if you reload or navigate away from the page`}
                  </Text>

                  {inventoryLogList.length > 0 && (
                    <Row>
                      <Col span={uomEnable ? 3 : 5}>
                        <Text strong>PO #</Text>
                      </Col>
                      <Col span={uomEnable ? 3 : 5}>
                        <Text strong>SKU</Text>
                      </Col>
                      {lotEnable && <Col span={3}>
                        <Text strong>LOT#</Text>
                      </Col>}
                      {uomEnable && <Col span={2}>
                        <Text strong>UOM</Text>
                      </Col>}
                      {uomEnable && <Col span={2}>
                        <Text strong>Rate</Text>
                      </Col>}
                      {uomEnable && <Col span={2}>
                        <Text strong>Base Qty</Text>
                      </Col>}
                      <Col span={3}>
                        <Text strong>Quantity</Text>
                      </Col>
                      <Col span={uomEnable ? 3 : 5}>
                        <Text strong>Location</Text>
                      </Col>
                      <Col span={3}>
                        <Text strong>Date</Text>
                      </Col>
                    </Row>
                  )}
                  {inventoryLogList.map((item, index) => (
                    <div key={index}>
                      <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                      <Row>
                        <Col span={uomEnable ? 3 : 5}>
                          <Text>{item.po}</Text>
                        </Col>
                        <Col span={uomEnable ? 3 : 5}>
                          <Text>{item.sku}</Text>
                        </Col>
                        {lotEnable && <Col span={3}>
                          <Text>{item.lotNumber}</Text>
                        </Col>}
                        {uomEnable && <Col span={2}>
                          <Text>{item.uom}</Text>
                        </Col>}
                        {uomEnable && <Col span={2}>
                          <Text>{item.uomRate}</Text>
                        </Col>}
                        {uomEnable && <Col span={2}>
                          <Text>{(item.uomRate || 1) * item.quantity}</Text>
                        </Col>}
                        <Col span={3}>
                          <Text>{item.quantity}</Text>
                        </Col>
                        <Col span={uomEnable ? 3 : 5}>
                          <Text>{item.location}</Text>
                        </Col>
                        <Col span={3}>
                          <Text>{item.date}</Text>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </LocationInfoBox>
              </TabPane>
            </Tabs>
          </LocationInfo>
        </InfoBox>
        {/* </InfoView> */}
      </Content>
      {selectLotUomDialogVisible && productInfo &&
        <SelectLotUomDialog
          uomEnable={uomEnable}
          lotEnable={lotEnable}
          timeZone={timeZone}
          onHide={()=>{
            setSelectLotUomDialogVisible(false)
          }}
          onOk={(data)=>{
            setLotUomInfo(data)
            setSelectLotUomDialogVisible(false)
          }}
          product={productInfo}
        />
      }
    </>
  );
}
